<div class="container mx-5"  *ngIf = "(track | async) as tr"> 
<ul class="timeline" id="timeline">
    <li  [className]="classNameStart" style="z-index: 50;" id="start">
        <div class="timestamp">
            <span class="author">{{tr.cityStart | uppercase}}</span>
            <span class="date">{{tr.dateStart}}</span>
          </div>
        <div class="status-first">
            <h5  class="mt-3"> {{getStatus('_START')}} </h5>
        </div>
    </li>
    <li [className]="classNameProcess" style="z-index: 30;" id="process">
      <div class="timestamp">
        <span class="author"></span>
        <span class="date"></span>
      </div>
      <div class="status">
        <h5  class="mt-3"> {{getStatus('_PROCESS')}} </h5>
      </div>
    </li>
   
    <li id="completed" [className]="classNameCompleted">
        <div class="timestamp">
            <span class="author">{{tr.cityEnd | uppercase}}</span>
            <span class="date">{{tr.dateEnd}}</span>
          </div>
        <div class="status">
            <h5  class="mt-3"> {{getStatus('_COMPLETED')}} </h5>
        </div>
    </li>
   </ul> 
   <div class="container mt-3">
    <div class="mt-3">
        <h4>Descripción</h4>
        <p class="info">{{tr.description}}</p>
    </div>
    <div class="">
        <div class="mt-4 container-picture"  *ngFor = "let img of (images | async)">
           <a href="{{img.url}}" target="_blank"><div class="picture"><img src="{{img.url}}"/></div></a>
        </div>   
     </div>     
</div>

